var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"spcc"}},[(_vm.layout=='hoesch')?_c('div',[_c('hoesch',{attrs:{"languages":_vm.languages}})],1):_vm._e(),_vm._v(" "),(_vm.layout=='gooimeer')?_c('div',[_c('gooimeer',{attrs:{"languages":_vm.languages}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29b9e1b6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Spcc.vue
// module id = 554
// module chunks = 0